import { render, staticRenderFns } from "./FeedbackAndSuggestion.vue?vue&type=template&id=fd2f70dc"
import script from "./FeedbackAndSuggestion.vue?vue&type=script&lang=js"
export * from "./FeedbackAndSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports